import debounce from "lodash.debounce";

export function partnershipsSlider() {
    $(".list-partnerships").each(function () {
        let _this = $(this);
        let attr = _this.attr('dir');
        let _rtl = typeof attr !== 'undefined' && attr === 'rtl';

        _this.on("destroy", function (_, slick) {
            const reinit = debounce(() => {
                if (slick.activeBreakpoint < window.innerWidth) return;
                $(this).slick(slick.options);
                window.removeEventListener("resize", reinit);
            }, 200);
            window.addEventListener("resize", reinit);
        }).slick({
            rtl: _rtl,
            cssEase: 'linear',
            slidesToScroll: 1,
            slidesToShow: 1.666,
            centerMode: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 3000,
            infinite: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 567,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 6
                    }
                },
                {
                    breakpoint: 1200,
                    settings: "unslick"
                }
            ]
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/partnershipsSlider.js